export default async function (rootElement) {
    const triggerButton = rootElement.querySelector('.js-accordion-trigger');
    triggerButton.addEventListener('click', (e) => {
        if (rootElement.classList.contains('is-open')) {
            closeAccordionItem(rootElement);
        } else {
            openAccordionItem(rootElement);
        }
    })
}

function findSiblingAccordionItems(item) {
    return item.parentElement.querySelectorAll('.js-accordion-item');
}

async function openAccordionItem(item) {
    const siblingAccordionItems = findSiblingAccordionItems(item);
    if (siblingAccordionItems.length) {
        siblingAccordionItems.forEach(siblingAccordionItem => {
            siblingAccordionItem.classList.remove('is-open');
        });
    }
    item.classList.add('is-open');
}

async function closeAccordionItem(item) {
    item.classList.remove('is-open');
}

export async function handleAccordionAutoOpenFromUrlHash() {
    if (window.location.hash) {
        const hashTargetAccordion = document.querySelector(window.location.hash)?.classList.contains('js-accordion-item');
        if (hashTargetAccordion) {
            await openAccordionItem(document.querySelector(window.location.hash));
        }
    }
}
